import React, { Component } from 'react';

import Loading from '../../../../facturotopia/loading/Loading';
import PageHeader from '../../../../support/page-header/PageHeader';
import ReceptoresExcelInfoData from './components/ReceptoresExcelInfoData';

class ReceptoresExcelInfo extends Component {

  state = {}

  constructor(props) {
    super(props);

    const { data = {}} = props.location.state || {};
    const { id } = this.props.match.params;

    this.state = {
      data: !!data.id ? { ...data } : { id }
    }
  }

  componentDidMount() {
    const { data } = this.state;

    if (!data.rfc) {
      this.props.history.replace('/app/receptores/excel')
      return;
    }
  }

  componentWillUnmount() {
    this.setState = () => {};
  }

  render() {
    const { data = {}, busy } = this.state;

    if (!!busy) {
      return <Loading className="text-info" />;
    }

    return (
      <>
        <PageHeader to="/app/receptores/excel" text="Excel receptores" />

        <ReceptoresExcelInfoData data={ data } />
      </>
    );
  }
}

export default ReceptoresExcelInfo;